import { CancelInsuranceFormData } from '@/interfaces';

export const isNotCoolingPeriod = (details: CancelInsuranceFormData) => {
  return !details.isCoolingPeriod;
};

export const CancelInsuranceDisplayRules = {
  isNotCoolingPeriod,
};
